// eslint-disable-next-line jira/filename-case
import React, { type RefObject } from 'react';
// eslint-disable-next-line jira/restricted/@atlaskit+modal-dialog
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';
import type { MaybeChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import { shouldBeChoreographed } from '@jira/platform__choreographer-services/src/utils.tsx';
import { isSupportedUserAgent } from '@jira/platform__is-mobile-user-agent/src/index.tsx';
import { ChoreographerModal } from './ChoreographerModal.tsx';

export type JiraModalProps = ModalDialogProps &
	MaybeChoreographedComponentProps &
	// A small manual change until we roll out type change in base atlaskit modal package
	// See DSP-21837
	{ autoFocus?: RefObject<HTMLElement | null | undefined> };

export const JiraModal: {
	(props: JiraModalProps): React.JSX.Element | null;
	displayName: string;
} = (props: JiraModalProps): React.JSX.Element | null => {
	if (shouldBeChoreographed(props)) {
		if (isSupportedUserAgent()) {
			return null;
		}
		const { messageType, ...rest } = props;
		return <ChoreographerModal {...rest} />;
	}

	const { messageType, messageId, onMessageDisposition, ...rest } = props;
	return <Modal {...rest} />;
};

JiraModal.displayName = 'JiraModal';
